import { TargetGroupWithTargets } from "components/product-collection/footer/types";
import { COLLECTIONS } from "constants/action-types";
import { AllocationBag, AllocationBagType } from "helpers/allocation-dimension";

// --------------------Targets-------------------- //
export type RemoveTargetPayload = {
    targetGroupId: string;
    targetsIds: string[];
    queueOptions: { targetName: string };
};

export type SaveTargetObjectsPayload = {
    targetGroupWithTargets: TargetGroupWithTargets;
    targetBag: AllocationBag;
    queueOptions: { targetName: string };
};

// --------------------Target Groups-------------------- //
export type SyncTargetGroupsCompletedPayload = { collectionId: string };

export const syncTargetGroupsCompletedAction = (payload: SyncTargetGroupsCompletedPayload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.TARGET_GROUPS.SYNC.COMPLETED,
});

// --------------------Target Bag Values-------------------- //
export interface IMutateTargetAllocationBagValue {
    bagType: AllocationBagType;
    rowId: string;
    dimensionValues: string[];
    quantity: number;
}

export const bulkMutateTargetAllocationBag = (collectionId: string, values: IMutateTargetAllocationBagValue[]) => ({
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.BAG_VALUE.BULK_MUTATE,
    payload: { collectionId, values },
});

// --------------------Queue-------------------- //

export type CreateQueueActionPayload = { operations: any[]; targetName: string };
export enum TargetsQueueType {
    EDIT = "EDIT",
    CREATE = "CREATE",
    REMOVE = "REMOVE",
}

export const createTargetsQueue = (payload: CreateQueueActionPayload) => ({
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.QUEUE.CREATE,
    payload,
});

export const executeTargetsQueueAction = () => ({
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.QUEUE.EXECUTE,
});

export const shiftTargetsQueueAction = () => ({
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.QUEUE.SHIFT,
});

export const clearTargetsQueueAction = () => ({
    type: COLLECTIONS.COLLECTION.TARGET_METRICS.QUEUE.CLEAR,
});
